import React from "react";
import socketio from "socket.io-client";

export const socket = socketio.connect('https://inloopapp-api.iosx.in', {
  query: {
    "accesstoken": localStorage.getItem('auth_token')
  }
});
export const SocketContext = React.createContext();